export default __webpack_public_path__ + "static/media/Pneum.32852eb6.png";